import React from "react";
import { Box } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

interface PreviewThumbProps {
  preview?: any;
  onDeleteUploadFile: (file: any) => void;
  index?: number;
}

const PreviewThumb: React.FC<PreviewThumbProps> = ({
  preview,
  onDeleteUploadFile,
  index,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        borderRadius: 2,
        border: "1px solid #eaeaea",
        marginBottom: 2,
        marginRight: 8,
        width: "100%",
        height: "250px",
        padding: 1,
        boxSizing: "border-box",
        "& img": {
          display: "block",
          width: "100%",
          objectFit: "cover",
          height: "100%",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          right: 10,
          top: 10,
        }}
      >
        <DeleteOutlineOutlinedIcon
          sx={{
            fontSize: 40,
            color: "text.secondary",
            borderRadius: "50%",
            padding: 1,
            "&:hover, &:focus": {
              color: "warning.main",
              backgroundColor: "primary.contrastText",
            },
          }}
          onClick={() => onDeleteUploadFile(index ?? preview)}
        />
      </Box>
      <img alt="preview" src={preview} width="100%" />
    </Box>
  );
};

export default PreviewThumb;
